import { takeLatest } from 'redux-saga/effects';
import * as ActionTypes from './ActionType';
import { GetOnboardingEnableSaga } from './OnboardingSaga';

export default function* OnboardingWatcher() {
    yield takeLatest(ActionTypes.ONBOARDING_ENABLE_ADD_REQUEST, GetOnboardingEnableSaga);
}
